import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';

class AdditionalCostsPositions extends React.Component {
  render() {
    const { intl, projectConfig, additionalCostsPositions, additionalCostsTotal } = this.props;
    const messages = intl.messages;

    return (
      <div>
        <h4 class="text-danger">{messages.additional_costs_due}</h4>

        <table class="table table-condensed" key="items-list">
          <tbody>
            {additionalCostsPositions.map((additionalCostsPosition, i) => {
              return (
                <tr key={i}>
                  <td class="v-align-middle">{additionalCostsPosition.name}</td>
                  <td class="v-align-middle text-right">
                    {additionalCostsPosition.quantity} {additionalCostsPosition.quantityUnitSymbole}
                  </td>
                  <td class="v-align-middle text-right">
                    <FormattedNumber
                      value={additionalCostsPosition.grossPrice}
                      style="currency"
                      currency={projectConfig.data.currency}
                    />
                  </td>
                  <td class="v-align-middle text-right">
                    <h4 class="text-primary no-margin font-secondary">
                      <FormattedNumber
                        value={additionalCostsPosition.price}
                        style="currency"
                        currency={projectConfig.data.currency}
                      />
                    </h4>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Row class="b-a b-grey no-margin">
          <Col xs={7} />

          <Col xs={5} class="text-right bg-primary padding-10">
            <h5 class="font-secondary all-caps small no-margin hint-text text-white bold">{messages.salesDoc.total}</h5>
            <h4 class="no-margin text-white">
              <FormattedNumber value={additionalCostsTotal} style="currency" currency={projectConfig.data.currency} />
            </h4>
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectIntl(AdditionalCostsPositions);
